module.exports = __webpack_public_path__ + "static/media/ua-ua.08303df9.png";